module.exports = __webpack_public_path__ + "images/no-image-image.png";